module.exports = __webpack_public_path__ + "images/marketing/peeps/likes/scott_gibson.jpg";